import { notifications } from '@mantine/notifications';

// Centrale meldingen-helper. Vervangt de oude custom Toast: overal in de app
// dezelfde stijl, kleuren en positie. addToast(message, type) blijft als
// signatuur bestaan zodat bestaande aanroepen (fetchWithAuth, hooks) werken.
const KLEUR = {
  success: 'green',
  error: 'red',
  warning: 'yellow',
  info: 'blue',
};

export function notify(message, type = 'info') {
  notifications.show({
    message,
    color: KLEUR[type] || 'blue',
    autoClose: type === 'error' ? 6000 : 3500,
    withBorder: true,
  });
}

export default notify;
